/**
 * The `landing_cta_clicked` `cta_variant` values the hero's returning-visitor
 * pair sends (#1066), and arm B's two strip CTAs (#1070). The older CTAs keep
 * their literals at their call sites in the arm.
 *
 * In a module of their own because the arm sends them and `LegacyHomepage`
 * routes on {@link HERO_LOG_IN_CTA}. Declared in `LegacyHomepage`, the arm's
 * import would close a cycle through `variants/registry.ts`, which imports
 * the arm.
 */

/**
 * The hero button on a device somebody has signed in on before, which reads
 * "Log in". It goes to `/sign-in`.
 */
export const HERO_LOG_IN_CTA = "hero_log_in";

/**
 * The "New here? Create an account" link under that button. It goes to
 * `/sign-up`, as the new-visitor hero does.
 */
export const HERO_NEW_HERE_CTA = "hero_new_here";

/**
 * Arm B's CTA under Strip A, "Every reflection, ready to revisit" (#1070). It
 * goes to `/sign-up`, as the other registering CTAs do.
 */
export const STRIP_A_CTA = "strip_a_cta";

/**
 * Arm B's CTA under Strip B, "Talk for a minute. Get back what stood out"
 * (#1070). It goes to `/sign-up`.
 */
export const STRIP_B_CTA = "strip_b_cta";
